<template>
  <Shell :current-route="currentRoute" homeRoute="crm">
    <template #appName>CRM</template>
<!--    <template v-if="currentRoute">-->
<!--      <vnt-dashboard v-if="shouldShowWebComponent"></vnt-dashboard>-->
<!--      <p class="d-none">Current CRM route name: {{ currentRoute.name }}</p>-->
<!--    </template>-->
    <CrmContent @route-changed="handleRouteChange" />
  </Shell>
</template>

<script>
import {ref, computed, onMounted, onUnmounted, h} from 'vue';
import Shell from "@/layouts/shell.vue";
import { defineAsyncComponent } from 'vue'

const CrmContent = defineAsyncComponent(() =>
    import("crm/main").then(({ mount }) => ({
      setup(props, { emit }) {
        const el = ref(null);
        let router;

        onMounted(() => {
          const instance = mount(el.value);
          router = instance.router;
          router.afterEach((to) => {
            emit('route-changed', {
              name: to.name,
              fullPath: to.fullPath,
              path: to.path,
              meta: to.meta,
            });
          });
        });

        onUnmounted(() => {
          if (router) {
           window.location.reload();
          }
        });

        return () => h("div", { ref: el });
      }
    }))
);

export default {
  components: {
    CrmContent,
    Shell,
    // MyWebComponent: () => import('./path-to-my-web-component.vue')
  },
  setup() {
    const currentRoute = ref(null);

    const handleRouteChange = (route) => {
      currentRoute.value = route;
    };

    const shouldShowWebComponent = computed(() => {
      return currentRoute.value;
    });

    return {
      handleRouteChange,
      shouldShowWebComponent
    };
  }
};
</script>

<style scoped>
#apps {
  /* Your styles here */
}
</style>